export default __webpack_public_path__ + "static/media/8_1.8a5b1d7a.jpg";